import React, { useCallback, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, withRouter } from 'react-router-dom';
import {
    getBettingGames,
    getGameUrls,
} from "../../../../../store/selectors";
import { requestGameUrl, removeGameUrl } from '../../../../../store/actionCreators/gameUrl';
import { CloseHeader } from "./components";
import { LoadingPage } from "./components";
import gbParams from '../../../../../config/parameters';
import { faSpinner, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome/index';

const BettingTab = ({ isLeague, onClose }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();
    const bettingGames = useSelector(getBettingGames);
    const [gameId, setGameId] = useState();
    const gameUrls = useSelector(getGameUrls);

    const [isFrameVisible, setIsFrameVisible] = useState(false);
    const [casinoUrl, setCasinoUrl] = useState('');

    const loadSportFrame = useCallback(() => {
        if (bettingGames.length === 0) return;
        const bettingGame = bettingGames[0]
        setGameId(bettingGame.id);
        dispatch(requestGameUrl({ game: bettingGame, isVirtual: false, isMobile }));
    }, [bettingGames]);


    useEffect(() => {
        if (!!gameUrls && !!gameId && !!gameUrls[gameId]) {
            openSlot(gameUrls[gameId]);
        }
    }, [gameUrls[gameId]]);

    const closeCasino = useCallback(() => {
        dispatch(removeGameUrl(gameId));
        setIsFrameVisible(false);
        setCasinoUrl('');
        setGameId();
        if (onClose) onClose();
        if (isLeague) history.goBack();
    }, [gameId]);

    const showIFrame = useCallback(() => {
        setIsFrameVisible(true);
    }, [isFrameVisible]);

    const openSlot = useCallback(url => {
        if (!url) return;
        if (isMobile) {
            setCasinoUrl(url);
        } else {
            window.open(url, '', [
                'width=' + gbParams.dimensions.slot.width,
                'height=' + gbParams.dimensions.slot.height,
                'resizable=0',
                'scrollbars=1',
                'top=' + (window.screen.height - gbParams.dimensions.slot.height - 100) / 2,
                'left=' + (window.screen.width - gbParams.dimensions.slot.width) / 2
            ].toString());
        }
    });

    return (
        <>
            {
                gameId && casinoUrl &&
                <div className={`casinoFrame betting ${isFrameVisible ? 'visible' : 'loading'}`}>
                    {
                        !isFrameVisible ?
                            <LoadingPage
                                type={'sports'}
                                onClose={() => closeCasino()}
                            />
                            : false
                    }
                    <CloseHeader onClose={() => closeCasino()} type={ !isLeague && 'sports'}/>
                    <iframe
                        src={casinoUrl}
                        onLoad={showIFrame}
                    />
                </div>
            }
            <div className="bettingEntering">
              <p className="bettingEnteringText">{t('club.games.betting.enterText')}</p>
              <button className="bettingLoaderButton" onClick={loadSportFrame}>{t('club.games.betting.goToSports')}</button>
            </div>
        </>
    );
};

export default withRouter(BettingTab);
